import { createFileRoute } from "@tanstack/react-router";
import { requireRole } from "@/auth/requireRole.ts";
import { ROLE_ADMIN } from "@/constants";

export const Route = createFileRoute("/_dashboard/modules")({
  beforeLoad: (args) => {
    requireRole([ROLE_ADMIN])(args);
  },
});
